import { Routes } from '@angular/router';
import { AjudaComponent } from './components/ajuda/ajuda.component';
import { AuditoriaComponent } from './components/auditoria/auditoria.component';

import { IntroComponent } from './components/intro/intro.component';
import { PrivacyComponent } from './components/privacy/privacy.component';
import { ProfileComponent } from './components/profile/profile.component';
import { RulesComponent } from './components/rules/rules.component';

export const routes: Routes = [
  { path: '', component: IntroComponent, pathMatch: 'full' },
  { path: 'ajuda', component: AjudaComponent, pathMatch: 'full' },
  { path: 'auditoria', component: AuditoriaComponent, pathMatch: 'full' },
  { path: 'privacy', component: PrivacyComponent, pathMatch: 'full' },
  { path: 'regras', component: RulesComponent, pathMatch: 'full' },
  { path: 'perfil', component: ProfileComponent, pathMatch: 'full' },
  { path: 'jogos', loadChildren: () => import('./games/games.routes').then(m => m.routes) },
  { path: 'grupos', loadChildren: () => import('./groups/groups.routes').then(m => m.routes) },
  { path: 'adm', loadChildren: () => import('./admin/admin.routes').then(m => m.routes) },
  { path: 'galeria', loadChildren: () => import('./galeria/galeria.routes').then(m => m.routes) },
  { path: 'audit', loadChildren: () => import('./audit/audit.routes').then(m => m.routes) },
];
